<template>
  <div>
    <LoadingOverlay v-if="isLoading" />
    <div class="box uk-margin-top uk-animation-fade">
      <h2 class="box-heading">
        User Profile
      </h2>
      <b-form @submit="submitEditUser">
        <div class="box-content">
          <b-form-group
            id="editUserName"
            label="Name:"
            label-for="editUserNameInput"
          >
            <b-form-input
              id="editUserNameInput"
              v-model="userName"
              type="text"
              required
              placeholder="Enter your full name"
            />
          </b-form-group>
          <b-form-group
            id="editUserLocation"
            label="Email"
            label-for="editUserLocationInput"
          >
            <b-form-input
              id="editUserLocationInput"
              v-model="userEmail"
              type="text"
              required
              placeholder="Enter Email Address"
            />
          </b-form-group>
          <div class="text-center">
            <b-button
              type="submit"
              class="box-button"
            >
              Update Details
            </b-button><br>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { emitToast, VARIANT_TYPE } from '../../../util/Toast';
import LoadingOverlay from '../../common/LoadingOverlay';

export default {
  name: 'EditUserIndex'.toLowerCase(),
  components: { LoadingOverlay },
  props: {
    email: {
      type: String,
      required: true,
    },
    // eslint-disable-next-line vue/prop-name-casing
    user_id: {
      type: Number,
      required: true,
    },
    // eslint-disable-next-line vue/prop-name-casing
    user_name: {
      type: String,
      required: true,
    },
  },
  data: function() {
    return ( {
      isLoading: false,
      userEmail: this.email,
      userId: parseInt(this.user_id),
      userName: this.user_name,
    } );
  },

  methods: {
    async submitEditUser(event) {
      event.preventDefault();
      this.isLoading = true;
      try {
        await axios.post('/api/user/profile/update', {
          email: this.userEmail,
          name: this.userName,
          userId: this.userId,
        });
        emitToast(this.$bvToast, VARIANT_TYPE.SUCCESS, 'Your information has been updated!');
      } catch (e) {
        let errorMessage = 'An error occurred while updating your information. Please refresh and try again.';
        emitToast(this.$bvToast, VARIANT_TYPE.WARNING, errorMessage);
      }
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>

</style>